import styled from "@emotion/styled";
import { BLUE_LIGHT, OLD_BLUE, PRIMARY_BLACK } from "src/constants/colors";

export const Container = styled.div`
  position: relative;
`;

export const List = styled.div<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? "flex" : "none")};
  background-color: rgb(255, 255, 255);
  border: 1px solid rgba(228, 231, 236, 1);
  border-radius: 12px;
  box-shadow:
    0px 2px 8px rgba(0, 0, 0, 0.06),
    0px 16px 64px -12px rgba(0, 0, 0, 0.1);
  flex-direction: column;
  gap: 4px;
  padding: 6px;
  position: absolute;
  top: 36px;
  right: 0px;
  width: 194px;
  z-index: 9999;
`;

export const ListTitle = styled.div`
  color: rgba(74, 84, 102, 1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  padding: 8px;
  font-size: 12px;
`;

export const ListItem = styled.div`
  border-radius: 6px;
  color: ${PRIMARY_BLACK};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  height: 34px;
  padding: 8px;
  cursor: pointer;

  &:hover {
    background-color: ${BLUE_LIGHT};
    color: ${OLD_BLUE};
  }
`;

export const LeftSideGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

export const RightSideGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

export const LeftIconSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
`;

export const TextSlot = styled.div<{ hasLeftIcon?: boolean }>`
  text-align: ${({ hasLeftIcon }) => (hasLeftIcon ? "left" : "center")};
  padding-left: ${({ hasLeftIcon }) => (hasLeftIcon ? "8px" : "0px")};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 16px;
`;

export const RightIconSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 18px;
`;

export const ButtonIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;

  & > svg {
    width: 14px;
    height: 14px;
  }
`;
